module.exports = __webpack_public_path__ + "static/media/region_icon.84049302.svg";